<template>
  <div :class="`webcast ${ratio}`">
    <!-- 页面标题 -->
    <div v-wechat-title="'蜗蜗直播 亏掉底裤 -《最强蜗牛》'"></div>

    <div :class="`content ${isLoad}`">
      <!-- 头部 -->
      <div :class="['header', user_info.rid ? 'login' : '']">
        <div class="account">{{ user_info.rid ? `${user_info.role_name} ${user_info.server_name ? `[${user_info.server_name}]` : ''}` : "加入黄鹂鸟,干翻黑心蜗！" }}</div>
        <div :class="['btn', user_info.channel === 'android' || user_info.channel === 'ios' ? 'change' : '' ]" @click="headerBtn()"></div>
      </div>

      <!-- 首页 -->
      <div class="home" v-show="comic === 4" @click="checkLogin() ? enterRoom() :  enterRoom()"></div>

      <!-- 直播间 -->
      <div :class="`room ${title ? '' : 'over'}`">
        <!-- 福袋 -->
        <div :class="`luck ${fu_reward}`" @click="isAni ? '' : showPopup('luck')"></div>
        <div class="role" @click="comic = 4">
          <div :class="`item item-0${item}`" v-for="(item,index) in roleArr" :key="index"></div>
        </div>
        <!-- 货品展示架 -->
        <div :class="`shelf shelf-0${good_id}`">
          <!-- 展示商品：shelf-01：欧神Passion奖券包，shelf-02：天堂鸟装修礼包，shelf-03：生擒神龙飞升包，shelf-04：一代宗师不坑神卷，shelf-05：走近蜗学掘地包，shelf-06：科技争霸狠活装 -->
          <div :class="`prize prize-0${answer_number}`">
            <!-- 修改初始金额：prize-01为999，prize-02为233，prize-03为79；砍价动画：添加ani类名 -->
            <div class="icon"></div>
          </div>
        </div>
        <!-- 告示板块 -->
        <div class="board" v-show="!title">
          <span>{{ user_answer_id < 18 ? "主播去探索神域了，明天再来吧~" : "直播已结束" }}</span>
        </div>
        <!-- 明日商品 -->
        <div class="tomorrow" @click="showPopup('list')" v-show="content.length">
          <div class="item" v-for="(item,index) in content" :key="index">
            <div class="pic"><img :src="item.pic"></div>
            <div class="title">{{ item.title }}</div>
            <div class="price" :text="item.price">{{ item.price }}</div>
          </div>
        </div>
        <div class="bottom">
          <!-- 蜗牛主播 -->
          <div :class="`snail face-0${face}`" v-show="title"><span></span></div>
          <!-- 对话文案 -->
          <div class="dialog" v-show="isDialog">
            <div class="wrap">
              <div class="text"></div>
            </div>
            <div class="btn" @click="atOnce" v-show="!is_finish || !answer_number === 1"></div>
          </div>
          <!-- 进房提示 -->
          <div :class="`notice comic-${comic}`"></div>
          <!-- 直播弹幕 -->
          <div class="barrage">
            <div :class="`item ${item.type}`" v-for="(item, index) in barrage" :key="index">
              <div class="name">{{ item.name }}：</div>
              <div class="msg">{{ item.msg }}</div>
            </div>
          </div>
          <!-- 底栏按钮 -->
          <div class="icon">
            <div :class="['box', title ? '' : 'false']" @click="!isAni && !popup.next && !isDialog ? showPopup('question') : ''"></div>
            <div class="wrap">
              <div class="item" @click="isAni ? '' : showPopup('list')"></div>
              <div class="item" @click="isAni ? '' : showPopup('share')"></div>
              <div :class="['item', click_number >= 11 ? 'egg' : '', cai_reward ? 'true' : '']" @click="isAni ? '' : clickEgg()">
                {{ click_number && click_number <= 10 ? click_number : "" }}
              </div>
              <div class="item" @click="isAni ? '' : showPopup('rule')"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 弹窗 -->
      <div class="popupWrap" v-show="comic === 0">
        <!-- 过渡 -->
        <div :class="`popup next ${popup.next}`">
          <div class="popup-main" @click="nextBtn()">
            <div class="text">{{ is_finish ? "查看下一件商品" : answer_number === 1 ? "反驳" : "继续反驳" }}</div>
            <div class="times" v-show="!is_finish">当前马甲数：<span>{{ times }}</span></div>
          </div>
        </div>

        <!-- 福袋 -->
        <div :class="`popup luck ${popup.luck}`" @click.self="popup.luck = false" >
          <div class="popup-main">
            <div class="btn" @click="onReward(2)"></div>
          </div>
        </div>

        <!-- 彩蛋 -->
        <div :class="`popup egg ${popup.egg}`" @click.self="popup.egg = false">
          <div class="popup-main">
            <div class="btn" @click="onReward(1)"></div>
          </div>
        </div>

        <!-- 规则 -->
        <div :class="`popup rule ${popup.rule}`" @click.self="popup.rule = false">
          <div class="popup-main">
            <div class="wrap">
              <div class="inner"></div>
            </div>
          </div>
        </div>

        <!-- 分享 -->
        <div :class="`popup share ${popup.share}`" @click.self="popup.share = false">
          <div class="popup-main">
            <div class="total">累计已助力<span>{{ help_count }}</span>次</div>
            <div class="wrap">
              <div class="item" v-for="(item, index) in friends" :key="index">
                <div class="photo"><img :src="item.avatar" /></div>
                <div class="name">{{ item.nickname }}</div>
                <div class="time">24/{{ item.created_at.split(" ")[0] }}</div>
              </div>
            </div>
            <div class="none" v-show="!friends.length"></div>
            <div class="today">今日已助力:<span>{{ today_help_count }}/5</span></div>
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接" :data-clipboard-text="share_text"></div>
          </div>
        </div>

        <!-- 捣乱成功 -->
        <div :class="`popup success ${popup.success}`">
          <div class="popup-main">
            <div class="confirm-btn" @click="onSuccess()"></div>
          </div>
        </div>

        <!-- 捣乱失败 -->
        <div :class="`popup fail ${popup.fail}`" @click.self="closeFail()">
          <div :class="`popup-main times-${times} ${numAni ? 'ani' : ''}`">
            <div class="challenge-btn" @click="onFail()" v-show="times"></div>
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" v-show="!times" data-event="复制活动链接" :data-clipboard-text="share_text"></div>
            <div class="times">当前马甲:<span>{{ times }}</span></div>
          </div>
        </div>

        <!-- 质疑 -->
        <div :class="`popup question ${popup.question}`">
          <div class="popup-main">
            <div class="dialog"></div>
            <div :class="`goods shelf-0${good_id}`">
              <div :class="`prize prize-0${answer_number}`">
                <div class="icon"></div>
              </div>
            </div>
            <div class="close-btn" @click="closeQuestion()"></div>
            <div class="option">
              <div :class="['item', correct_id === index + 1 || is_first ? '' : 'false']" @click="onAnswer({ msg: answer[index], answer: index + 1 })" v-for="(item,index) in 2" :key="index">
                <span>{{ answer[index] }}</span>
              </div>
            </div>
            <div class="keyboard"></div>
            <div class="bird"></div>
          </div>
        </div>

        <!-- 购物车商品列表 -->
        <div :class="`popup list ${popup.list}`" @click.self="popup.list = false">
          <div class="popup-main">
            <div class="wrap">
              <div :class="['item', index + 1 === good_id ? 'active' : (item.is_open ? (index + 1 > good_id ? 'wait' : 'over') : 'way'), ]" v-for="(item, index) in good_list" :key="index">
                <!-- active正在讲解，wait即将讲解，over已兑换，way正在路上 -->
                <div class="date">{{ `开启时间:${item.start_at.replaceAll('-', '.')}` }}</div>
                <div class="pic"><img :src="item.pic"></div>
                <div class="title">{{ `【双十一·三只蜗专享】${item.title}` }}</div>
                <div class="des">
                  <div class="item" v-for="(itemB,indexB) in item.des.split('，')" :key="indexB">{{ itemB }}</div>
                </div>
                <div class="price" :text="item.price">{{ item.price }}</div>
                <div :class="['num', `num-${item.num}`]">
                  <div class="inner" :style="{'--width': `${30 + item.num * 5}%`}">{{ item.is_open ? (index + 1 >= good_id ? (index + 1 === good_id ? `剩余${item.num}件` : '剩余100+件') : '已售空') : '剩余100+件' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 防抖遮罩 -->
        <div :class="`popup mask ${popup.mask}`"></div>
      </div>

      <!-- 登录弹窗 -->
      <Login v-if="isShowLogin" v-on:channelCallback="selectCallback()" :gameName="gameName" :loginTypes="loginTypes" :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>

      <!-- 绑定弹窗 -->
      <Os v-if="isShowOs" v-on:selectCallback="selectCallback()" v-on:logoutCallback="osCancel" :gameName="gameName"></Os>
    </div>

    <!-- 漫画页 -->
    <div :class="`comic ${isLoad}`" @click="handleComic(comic)" v-if="comic && comic !== 4">
      <!-- 第一页 -->
      <div :class="`page page-01 comic-${comic}`" v-show="comic === 1 || comic === 1.5" >
        <div class="item">
          <div class="text" print="家人们！小蜗/又来发福利啦！"></div>
          <div class="text" print="今天好物多多/我们有———"></div>
        </div>
        <div class="item">
          <div class="text" print="居里夫人发明/的美蜗月饼！"></div>
        </div>
        <div class="item">
          <div class="text" print="地球意志的/淋巴肉…结！"></div>
        </div>
        <div class="item">
          <div class="text" print="业界名厨的/拿手菜！"></div>
        </div>
        <div class="item">
          <div class="text" print="还有全网唯一的/超级器官一套，只要/———648! ! !"></div>
        </div>
        <div class="item"></div>
      </div>
      <!-- 第二页 -->
      <div :class="`page page-02 comic-${comic}`" v-show="comic === 2 || comic === 2.5">
        <div class="item"></div>
        <div class="item">
          <div class="text" print="呜…被坑了…/是假货…"></div>
        </div>
        <div class="item">
          <div class="talk"></div>
        </div>
        <div class="item">
          <div class="text" print="诚你个奶奶！"></div>
        </div>
        <div class="item">
          <div class="text" print="臭蜗牛等着！/我要代表正义/打假你！！"></div>
        </div>
      </div>
      <!-- 第三页 -->
      <div :class="`page page-03 comic-${comic}`" v-show="comic === 3 || comic === 3.5">
        <div class="phone">
          <div class="title"></div>
          <div class="text" print="帮助黄鹂鸟打倒黑心商家，/整顿直播带货的乱象！"></div>
          <div class="btn" @click="closeComic()"></div>
        </div>
      </div>
    </div>

    <!-- 加载页 -->
    <div :class="`preload ${isLoad}`">
      <div class="process">
        <div class="line" :style="`width: ${process}%`"></div>
      </div>
    </div>

    <img src="../../../../assets/images/active/snail/webcast/popup/question_bird.gif" style="display: none;">
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "mint-ui";
import Clipboard from "clipboard";
import { mapState, mapMutations, mapActions } from "vuex";
import { getTimeStamp, buriedLogger, analysisParams } from "@/utils/utils";
import Login from "@/components/login";
import Os from "@/components/os";
import { onInitAPI, onLogoutAPI, onAnswerAPI, onEggAPI, onRewardAPI, onUuidAPI } from "../api";

export default {
  name: "webcast",
  data() {
    return {
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: "http://snail.qingcigame.com/official/",
      process: 3, // 预加载进度
      isLoad: false, // 是否完成预加载
      comic: 0, // 漫画页进度，0不展示，0.5待展示，1展示第一页，1.5完成第一页，2展示第二页，2.5完成第二页，3展示第三页，3.5完成第三页, 4首页
      ratio: "", // 屏幕比例
      share_text: "", // 分享文案
      barrage: [], // 弹幕数据，type默认为空，黄鹂鸟回复为'bird'
      barrageTotal: [
        { name: "杀手1号", msg: "祝主播大卖~(主播记得蝌蚪返现哦)", type: "" },
        { name: "王子", msg: "错过一次再等一年！", type: "" },
        { name: "诸葛亮", msg: "想要黄鹂鸟羽毛做的扇子", type: "" },
        { name: "朴巨姬", msg: "oi小蜗，直播间有点火热呢~", type: "" },
        { name: "沧龙", msg: "第一次看蜗牛直播好激动！", type: "" },
        { name: "顶罐子蜗牛", msg: "欧巴好帅~捧场！", type: "" },
        { name: "神龙", msg: "呵呵，买点供奉甜品吧", type: "" },
        { name: "春姬", msg: "买到就是赚到啊！", type: "" },
        { name: "赤兔吕布", msg: "给我赤兔来把加特林！", type: "" },
        { name: "杀手4号", msg: "宝刀来一把！", type: "" },
        { name: "女妖精", msg: "都有些什么这么热闹！", type: "" },
        { name: "猗猗卡卡", msg: "嗷呜嗷呜~嗷呜~", type: "" },
        { name: "魔春姬", msg: "有器官食材吗？想吃火锅了", type: "" },
        { name: "下水道乌龟", msg: "我要能划船的龟壳儿！", type: "" },
        { name: "那只猴子", msg: "哟，上班时间搁这儿偷偷赚外快呢？", type: "" },
        { name: "龙女中枢", msg: "不考虑到我这进货？", type: "" },
        { name: "犬武士", msg: "有无四魂之玉？", type: "" },
        { name: "太乙真人", msg: "我来搞点灵珠原料！", type: "" },
        { name: "屠夫", msg: "来盘焗蜗牛！", type: "" },
        { name: "未来猫", msg: "蝌蚪是活的吗？", type: "" }
      ], // 弹幕文本汇总
      timer: null, // 弹幕播报定时器
      welcome: [
        '无人扶我青云志,蜗家全网最低价!欢迎家人们光临三只蜗直播间~',
        '最近销售额不是很好,跟隔壁直播间的PK都输了,宝子们今天能不能努努力,送我上蜗布斯排行榜?',
        '家人们,欢迎光临!有两个消息,坏消息是再零元购蜗就要破产了!好消息是,今天蜗打死都不会降价了!'
      ], // 欢迎语
      isDialog: false, // 是否显示蜗牛主播对话框
      isAni: false, // 是否在质疑动画流程
      face: 1, // 蜗牛表情变化：1开心，2兴奋，3奸诈，4沮丧
      numAni: '', // 消耗马甲动画
      roleArr: [], // 直播间观众头像顺序
      isSpeak: false, // 蜗牛是否在说话
      speakType: false, // 蜗牛说话类型,true为提问，false为开场白
      timer2: null, // 重置isSpeak的计时器

      popup: {
        luck: false, // 福袋
        egg: false, // 彩蛋
        rule: false, // 规则
        share: false, // 分享
        success: false, // 捣乱成功
        fail: false, // 捣乱失败
        next: false, // 过渡按钮
        list: false, // 购物车商品列表
        question: false, // 质疑
        mask: false, // 防抖
      },

      user_info: {}, // 用户信息
      fu_reward: false, // 是否已领取福袋奖励
      cai_reward: false, // 是否已领取彩蛋奖励
      click_number: 0, // 点击彩蛋的次数
      times: 0, // 马甲数
      friends: [], // 助力榜成员
      today_help_count: 0, // 今日已助力
      help_count: 0, // 累计已助力
      answer: [], // 质疑选项
      answer_id: 1, // 题目索引，1-18
      answer_number: 0, // 该商品第几道题，1-3
      good_id: 0, // 第几个商品，1-6
      is_first: 1, // 本题目是否首次作答
      room_number: 1, // 第几轮，2个商品为1轮，共3轮，1-3
      title: "", // 问题
      correct_id: 1, // 正确答案id，1-2
      is_finish: false, // 当前商品问题是否全部完成
      content: [], // 明日商品信息
      good_list: [], // 购物车商品信息
      user_answer_id: '', // 玩家答完的题目数量
      reply: [], // 弹幕回复
    }
  },
  components: { Login, Os },
  computed: { ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]) },
  created() {
    if (!global.consoleSwitch) console.log = () => {}

    // 自适应
    window.addEventListener("pageshow", this.resize)
    window.addEventListener("resize", this.resize)

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()

    // 埋点
    const bl = buriedLogger("snail", "最强蜗牛_三只蜗直播间")
    this.logger = bl
    setTimeout(() => {
      this.logger.sum("最强蜗牛_三只蜗直播间_访问活动页")
    }, 200)

    this.isSetShare()
  },
  mounted() {
    this.preload()
    this.onInit()
    this.onAuto()
  },
  methods: {
    // 自适应
    resize() {
      if (window.innerWidth >= 540)
        document.documentElement.style.fontSize = "54px"
      if (this.timer1) clearTimeout(this.timer1)
      this.timer1 = setTimeout(() => {
        // 兼容宽屏
        const ratio = window.innerWidth / window.innerHeight
        if (ratio > 320 / 510) {
          this.ratio = "ratio1"
        } else if (ratio > 320 / 570) {
          this.ratio = 'ratio2'
        } else {
          this.ratio = ''
        }
      }, 320)
    },
    // 打开弹窗
    showPopup(name) {
      switch (name) {
        case "login":
          this.changeLoginPopup(true)
          this.logger.sum("最强蜗牛_三只蜗直播间_打开登录弹窗")
          break
        case "luck":
          if (!this.fu_reward) {
            this.popup.luck = true
            this.logger.sum("最强蜗牛_三只蜗直播间_打开福袋弹窗")
          }
          break
        case "egg":
          this.popup.egg = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开彩蛋弹窗")
          break
        case "rule":
          this.popup.rule = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开规则弹窗")
          break
        case "share":
          this.popup.share = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开分享弹窗")
          break
        case "success":
          localStorage.setItem(`snail_success_show_${this.user_info.rid}`, this.user_info.rid)
          this.popup.success = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开捣乱成功弹窗")
          break;
        case "fail":
          this.popup.fail = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开捣乱失败弹窗")
          break
        case "next":
          localStorage.setItem(`snail_next_show_${this.user_info.rid}`, this.user_info.rid)
          if (this.is_finish && this.answer_number === 1) {
            // 查看下一件商品按钮
            localStorage.setItem(`snail_toNext_show_${this.user_info.rid}`, this.user_info.rid)
          }
          if (this.title) this.popup.next = true
          break
        case "list":
          this.popup.list = true
          this.logger.sum("最强蜗牛_三只蜗直播间_打开购物车商品列表弹窗")
          break
        case "question":
          if (!this.title) return
          document.querySelector('.popup.question .dialog').innerHTML = this.title
          this.isDialog = false
          const wrap = document.querySelector('.popup.question .item')
          const text = document.querySelectorAll('.popup.question .item span')
          text.forEach(item => {
            item.style.transform = item.offsetWidth > wrap.offsetWidth *0.85 ? `scale(${(wrap.offsetWidth * 0.85 / item.offsetWidth).toFixed(2)})` : ''
          }) // 调整文字比例
          this.popup.question = true
          break
      }
    },
    // 登录校验
    checkLogin() {
      if (!this.user_info.rid) {
        this.onToast("请先登录")
        this.showPopup("login")
        return false
      }
      return true
    },
    // 预加载
    preload() {
      this.comic = localStorage.getItem("webcast_comic_finish") ? 4 : 0.5
      const timer = setInterval(() => {
        this.process >= 80 ? clearTimeout(timer) : this.process++
      }, 40)
      window.addEventListener("load", () => {
        this.spring()
        this.onRole()
        this.onBarrage()
        this.process = 83
        setTimeout(() => {
          this.isLoad = true
          if (this.comic === 0.5) {
            this.comic = 1
            const timeArr = [800, 2100, 3500, 5000, 6500, 8000]
            document.querySelectorAll(".page-01 .text").forEach((item,index) => { this.print({element: item, delay: timeArr[index]}) })
            setTimeout(() => { if (this.comic === 1) this.comic = 1.5 }, 12000)
          }
        }, 300)
      })
    },
    // 初始化
    onInit() {
      onInitAPI().then((response) => {
        if (Number(response.code) === 200) {
          this.onInitDataCallback(response)
          this.setUserInfo(response.data.userInfo)
          this.user_info = response.data.userInfo
          this.fu_reward = response.data.activity.fu_reward
          this.cai_reward = response.data.activity.cai_reward
          this.click_number = response.data.activity.click_number
          this.times = response.data.activity.times
          this.friends = response.data.activity.friends
          this.help_count = response.data.activity.help_count
          this.today_help_count = response.data.activity.today_help_count
          this.answer = response.data.activity.room_info.answer || []
          this.reply = response.data.activity.room_info.reply || []
          this.answer_id = response.data.activity.room_info.answer_id
          this.answer_number = response.data.activity.room_info.answer_number
          this.good_id = response.data.activity.room_info.good_id
          this.is_first = response.data.activity.room_info.is_first
          this.room_number = response.data.activity.room_info.room_number
          this.title = response.data.activity.room_info.title
          this.correct_id = response.data.activity.room_info.correct_id
          this.content = response.data.activity.next_answer_info.content || []
          this.good_list = response.data.activity.good_list
          this.user_answer_id = response.data.activity.user_answer_id
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      })
    },
    // 漫画页交互
    handleComic(index) {
      if (index <= 3) this.comic += 0.5
      switch (index) {
        case 1:
          document.querySelectorAll(".page-01 .text").forEach(item => { this.print({element: item, time: 0}) })
          break
        case 1.5:
          const timeArr = [1300, 9700, 11000]
          document.querySelectorAll(".page-02 .text").forEach((item,index) => { this.print({element: item, delay: timeArr[index]}) })
          break
        case 2:
          document.querySelectorAll(".page-02 .text").forEach(item => { this.print({element: item, time: 0}) })
          break
        case 2.5:
          this.print({element: document.querySelector(".page-03 .text"), delay: 1000})
          break
        case 3:
          this.print({element: document.querySelector(".page-03 .text"), time: 0})
          break
      }
    },
    // 关闭漫画
    closeComic() {
      localStorage.setItem("webcast_comic_finish", true)
      this.comic = 4
    },
    // 进入直播间
    enterRoom() {
      this.comic = 0
      // 欢迎语判断
      if (localStorage.getItem(`webcast_once_enter_${this.user_info.rid}`) === this.user_info.rid) {
        // 曾进入过直播间
        if (this.title && !this.isSpeak) this.speak({msg: this.welcome[this.room_number - 1]})
      } else {
        // 首次进入直播间
        this.speak({msg: this.welcome[0]})
        localStorage.setItem(`webcast_once_enter_${this.user_info.rid}`, this.user_info.rid)
      }
      setTimeout(() => { this.face = 2 }, 1500) // 蜗牛变兴奋
      
      const date = `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()}`
      if (localStorage.getItem(`snail_success_show_${this.user_info.rid}`) === this.user_info.rid) {
        // 未点击抱走商品按钮，重现
        this.showPopup('success')
      } else if (localStorage.getItem(`snail_next_show_${this.user_info.rid}`) === this.user_info.rid) {
        // 未点击过渡按钮，重现
        if (localStorage.getItem(`snail_toNext_show_${this.user_info.rid}`) === this.user_info.rid) {
          // 重现查看下一件商品
          this.is_finish = true
          this.showPopup('next')
        } else {
          this.is_finish = false
        }
      } else {
        this.is_finish = false
        if (localStorage.getItem(`date_${this.user_info.rid}`) !== date) localStorage.setItem(`date_${this.user_info.rid}`, date) // 每天首次进入记录日期
      }
    },
    // 开始/暂停循环弹幕
    onBarrage (isPause) {
      if (isPause) return clearInterval(this.timer)
      if (this.barrage.length < 5) {
        let index = Math.floor(Math.random() * (this.barrageTotal.length)) // 随机索引
        index = index > this.barrageTotal.length - 5 ? this.barrageTotal.length - 5 : index
        this.barrage = this.barrageTotal.slice(index, index + 5)
      }
      let arr = [...this.barrageTotal]
      this.timer = setInterval(() => {
        if (!this.title) return clearInterval(this.timer) // 当日已结束或直播已结束
        if (!arr.length) arr = [...this.barrageTotal]
        const index = Math.floor(Math.random() * (arr.length)) // 随机索引
        this.barrage.push(arr.splice(index, 1)[0])
        if (this.barrage.length > 6) {
          const barrage = document.querySelector(".bottom .barrage")
          const child = document.querySelector(".bottom .barrage .item")
          barrage.removeChild(child)
        }
      }, 3000)
    },
    /*
     * 功能：打印文本
     * @param element 必须，需要打印的元素
     * @param delay 非必须，延迟多久执行，默认为0，单位ms {number}
     * @param time 非必须，打印间隔，默认为80ms {number}
     */
    print({element, delay, time}) {
      const text = element.getAttribute("print")
      if (time === 0) element.setAttribute('at_once', true)
      delay = delay || 0
      time = time || 80
      setTimeout(() => {
        if (text && !element.innerHTML) {
          const textArr = text.split("")
          const timer = setInterval(() => {
            const str = textArr.shift()
            str === "/" ? (element.innerHTML += `<br/>`) : (element.innerHTML += str)
            if (!textArr.length || element.getAttribute('at_once')) clearInterval(timer)
            if (element.getAttribute('at_once')) {
              element.innerHTML = text.replaceAll('/', '<br/>')
              setTimeout(() => { element.removeAttribute('at_once') }, 500)
            }
          }, time)
        }
      }, delay)
    },
    // 登录/切换/注销按钮
    headerBtn() {
      const channel = this.user_info.channel
      if (channel) {
        channel === "android" || channel === "ios" ? this.changeOsPopup(true) : this.osCancel()
      } else {
        this.showPopup("login")
      }
    },
    // 注销
    osCancel() {
      onLogoutAPI({
        game_id: this.user_info.game_id
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.setInitUserInfo()
          this.comic = 4
          this.user_info = {}
          this.popup.next = false
          this.isDialog =  false
          this.isAni = false
          this.face = 1
          this.numAni = ''
          return
        }
        this.onToast(response.message)
      })
    },
    // 充值平台免登录
    onAuto() {
      const { os, role_id, token, zone, game_id, server_id, web_bonus_id } = analysisParams(location.href)
      if (!os) return
      onUuidAPI({os, role_id, token, zone, game_id, server_id, web_bonus_id}).then(() => {
        location.href = 'https://h5.qingcigame.com/snail/webcast/enter{timestemp}'
      })
    },
    /*
     * 功能：领取奖励
     * @param type 领取类型，1彩蛋，2福袋 {number}
     */
    onReward(type) {
      onRewardAPI({
        type
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.onInit()
          this.onToast("领取成功")
          if (type === 1) {
            this.popup.egg = false
            this.logger.sum("最强蜗牛_三只蜗直播间_领取彩蛋奖励")
          } else {
            this.popup.luck = false
            this.logger.sum("最强蜗牛_三只蜗直播间_领取福袋奖励")
          }
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      })
    },
    // 点击彩蛋
    clickEgg() {
      if (this.click_number < 11) {
        this.popup.mask = true
        document.querySelectorAll(".bottom .icon .item")[2].appendChild(document.createElement("span")) // 生成爱心动效
        onEggAPI().then((response) => {
          if (Number(response.code) === 200) {
            this.click_number = Number(response.data.click_number)
            switch (this.click_number) {
              case 1:
                this.onToast("里面似乎有什么东西？再点点试试~")
                break
              case 6:
                this.onToast("点赞键似乎松动了一点...")
                break
              case 11:
                this.showPopup("egg")
                break
            }
            this.popup.mask = false
            return
          }
          Number(response.code) !== 401 && this.onToast(response.message)
        })
      } else {
        this.cai_reward ? this.onToast('私房钱已被榨干QAQ...') : this.showPopup("egg")
      }
    },
    /*
     * 功能：点击答题
     * @param answer 回答id {number}
     * @param msg 回答内容 {string}
     */
    onAnswer({ answer, msg }) {
      this.isAni = true // 进入质疑动画流程
      onAnswerAPI({
        answer,
        answer_id: this.answer_id
      }).then((response) => {
        if (Number(response.code) === 200) {
          if (response.data.user_answer_id >= 18) this.logger.sum("最强蜗牛_三只蜗直播间_全部通关")
          setTimeout(() => {
            // 等待按钮回弹动效
            this.popup.question = false
            this.answer = response.data.room_info.answer || []
            this.answer_id = response.data.room_info.answer_id
            this.is_first = response.data.room_info.is_first
            this.room_number = response.data.room_info.room_number
            this.title = response.data.room_info.title || '占位'
            this.correct_id = response.data.room_info.correct_id
            this.is_finish = response.data.is_finish

            if (response.data.is_correct === 1) {
              // 回答正确
              onInitAPI().then((response) => {
                if (Number(response.code) === 200) {
                  this.times = response.data.activity.times
                  document.querySelector('.popup.fail .times span').innerHTML = this.times
                }
              })
              this.barrage.push({ name: "黄鹂鸟", msg, type: "bird" }) // 黄鹂鸟质疑
              this.onBarrage(true) // 暂停循环弹幕
              setTimeout(() => { this.onBarrage() }, 5000) // 恢复循环弹幕
              this.reply.forEach((item, index) => {
                const time = (index + 1) * 800
                setTimeout(() => {
                  this.barrage.push({ name: item.id, msg: item.content, type: "" }) // 观众质疑
                  if (index === this.reply.length - 1) this.reply = response.data.room_info.reply
                }, time)
              })
              setTimeout(() => {
                this.face = 4 // 蜗牛变沮丧
                document.querySelector(".shelf .prize").classList.add("ani") // 商品砍价动画
              }, 800)
              setTimeout(() => {
                if (!this.is_finish) {
                  // 该商品未答完
                  this.speak({msg: this.title, type: 'title'}) // 主播下一问
                  this.answer_number = response.data.room_info.answer_number
                } else {
                  // 当前商品已完成
                  this.showPopup("success")
                  this.isAni = false // 结束质疑动画流程
                }
              }, 2500)
            } else {
              // 回答错误
              if (this.times >= 0){
                this.showPopup("fail")
                this.isAni = false // 结束质疑动画流程
              }
            }
          }, 600)
          return
        } else {
          this.onToast(response.message)
          this.isAni = false // 结束质疑动画流程
        }
      })
    },
    // 捣乱成功弹窗-抱走商品按钮
    onSuccess() {
      localStorage.setItem(`snail_success_show_${this.user_info.rid}`, '')
      this.onInit()
      setTimeout(() => {
        if (this.title) {
          this.face = 1 // 蜗牛变开心
          if (this.is_finish && this.answer_number === 1) this.showPopup('next') // 展示'查看下一件商品'按钮
        }
        this.popup.success = false
      }, 500)
    },
    // 过渡弹窗按钮
    nextBtn() {
      localStorage.setItem(`snail_next_show_${this.user_info.rid}`, '')
      this.popup.next = false
      if (this.is_finish && this.answer_number === 1) {
        localStorage.setItem(`snail_toNext_show_${this.user_info.rid}`, '')
        this.speak({msg: this.title, type: 'title'}) // 蜗牛下一问
        setTimeout(() => { this.is_finish = false }, 1000) // 消失后切换按钮样式
        setTimeout(() => { if (!this.isAni && !this.popup.question) {this.showPopup('next')} }, 5000)
      } else {
        this.showPopup("question")
      }
    },
    // 捣乱失败弹窗-再次挑战按钮
    onFail() {
      this.numAni = true
      if (document.querySelector('.popup.fail .times span').innerHTML >= 1) document.querySelector('.popup.fail .times span').innerHTML--
      setTimeout(() => {
        this.popup.fail = false
        this.showPopup('question')
        this.numAni = false
      }, 500)
      setTimeout(() => { this.times = this.times - 1 }, 1000)
    },
    /*
    * 功能：蜗牛说活
    * @param msg 必需，说话文案 {string}
    * @param type 非必需，说话类型 {string}，'title'为提问,''为开场白，默认为''
    */
    speak ({msg, type}) {
      if (!this.title) return // 蜗牛已离开
      const time2 = type === 'title' ? 5000 : 3000 // 开场白时间3s，提问时间5s
      const time = Math.floor(time2 / msg.split('').length)
      this.speakType = type === 'title'
      msg = msg.replace(/<(?:.|\s)*?>/g, '') // 移除html标签
      const dialog = document.querySelector(".bottom .dialog .text")
      dialog.innerHTML = ""
      this.isDialog = true
      dialog.setAttribute("print", msg)
      this.print({element: dialog, time})
      if (this.speakType) this.face = 3 // 蜗牛变奸诈
      this.isSpeak = true
      this.timer2 = setTimeout(() => {
        this.isSpeak = false
        if (this.speakType) {
          this.showPopup('next') // 继续答题
          this.isAni = false // 结束质疑动画流程
        }
      }, time2)
    },
    // 蜗牛对话箭头
    atOnce () {
      if (this.isSpeak) {
        // 正在对话
        this.popup.mask = true
        const dialog = document.querySelector('.dialog .wrap .text')
        dialog.setAttribute('at_once', 'true')
        setTimeout(() => {
          dialog.removeAttribute('at_once')
          clearTimeout(this.timer2)
          this.isSpeak = false
          this.popup.mask = false
          if (this.speakType) {
            this.showPopup('next') // 继续答题
            this.isAni = false // 结束质疑动画流程
          }
        }, 500)
      } else {
        // 完成对话
        if (this.speakType) {
          this.showPopup('next')
        } else {
          this.speak({msg: this.title, type: 'title'})
        }
      }
    },
    selectCallback() {
      this.onInit()
      this.popup.next = false
      this.isDialog =  false
      this.isAni = false
      this.face = 1
      this.numAni = ''
      setTimeout(() => {
        this.user_info.channel === 'android' || this.user_info.channel === 'ios' ? this.logger.sum("最强蜗牛_三只蜗直播间_官服登录") : this.logger.sum("最强蜗牛_三只蜗直播间_渠道登录")
        this.enterRoom()
        document.querySelector('.popup.fail .times span').innerHTML = this.times
      }, 500)
    },
    // 按钮回弹
    spring() {
      document.querySelectorAll(".option .item").forEach((item, index) => {
        item.addEventListener("click", () => {
          item.classList.add("touch")
          setTimeout(() => {
            item.classList.remove("touch")
          }, 300)
        })
      })
    },
    // 观众头像随机
    onRole () {
      const arr = [1,2,3,4,5]
      const timer = setInterval(() => {
        const index = Math.floor(Math.random() * (arr.length))
        this.roleArr.push(arr.splice(index, 1)[0])
        if (this.roleArr.length >= 3) clearInterval(timer)
      }, 0)
    },
    // 点击阴影关闭捣乱失败弹窗
    closeFail () {
      this.popup.fail = false
      this.isDialog = true
      this.showPopup('next')
      setTimeout(() => { document.querySelector('.popup.fail .times span').innerHTML-- }, 500)
    },
    // 关闭质疑弹窗
    closeQuestion () {
      this.popup.question = false
      this.isDialog = true
      this.showPopup('next')
    },
    // 复制链接
    copyLink(copyName) {
      this.share_text = `【最强蜗牛】兄弟，我在蜗牛直播间因为文采斐然被封号了，能不能借你的马甲一用？要不要一起进来跟我零元购？链接：https://h5.qingcigame.com/snail/webcast/help${getTimeStamp()}?friend_id=${
        this.user_info.user_id
      }`
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on("success", (e) => {
        _this.onToast("复制成功")
        e.clearSelection()
        this.logger.sum("最强蜗牛_三只蜗直播间_复制成功")
      })
      clipboard.on("error", (e) => {
        _this.onToast("复制失败")
      })
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/webcast/enter${getTimeStamp()}`,
        title: "这次，蜗一定要上蜗布斯 - 《最强蜗牛》",
        imgUrl: "https://download4.qcplay.com/qcgame-api/c5RYqgXFjooSOnluqvwfkmSbhA51KnNBdXMad9RE.png",
        desc: "专柜保真零元购，黄鹂鸟邀你一起反抗黑心蜗直播间，让光棍节再次伟大！",
      });
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = { duration: 1000, className: "toasts" }
      if (!config) {
        console.error("缺少config参数")
        return false
      }
      if (typeof config === "string") curConfig.message = config
      Toast(curConfig)
    },
    // 前往重定向
    goLink(url, loggerName) {
      if (url === "") return
      this.logger.sum(loggerName)
      setTimeout(() => { window.open(url) }, 200)
    },
    ...mapMutations(["setUserInfo", "changeLoginPopup", "changeOsPopup", "setInitActiveInfo", "setInitUserInfo"]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
};
</script>

<style lang="less">
@import "./index.less";
</style>


// WEBPACK FOOTER //
// src/pages/snail/webcast/index/index.vue